<template>
	<div>
		<!-- =========== Start of Body ============ -->

		<div class="container">
			<div class="row">
				<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
					<div
						class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--10 bg-color--light--1"
					>
						<form class="form">
							<div
								class="alert alert-danger"
								role="alert"
								id="alert"
								v-show="alert"
							>
								<ul>
									<li v-for="err in errors" :key="err">
										{{ err[0] }}
									</li>
								</ul>
							</div>
							<div class="container">
								<div class="row">
									<div
										class="col-12 mx-auto color--white text-center mb-4 mb-lg-5"
									>
										<h4>
											اطلاعات تکمیلی
										</h4>
									</div>
								</div>
								<div class="row justify-content-between">
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.jobclass") }}</label
											>
											<select
												class="form-control form-control-sm"
												id="jobclass"
												v-model.trim="$v.jobClass.$model"
												:class="{ 'is-invalid': $v.jobClass.$error }"
											>
												<option value="0">{{ $t("register.staff") }}</option>
												<option value="1">{{
													$t("register.selfEmployment")
												}}</option>
												<option value="2">{{
													$t("register.pensioner")
												}}</option>
											</select>
											<div
												class="invalid-feedback"
												v-if="!$v.jobClass.required"
											>
												حوزه شغلی خود را وارد کنید
											</div>
										</div>
									</div>

									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.job") }}</label
											>
											<input
												id="job"
												type="text"
												v-model.trim="$v.job.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.job.$error }"
												@blur="$v.job.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.job.$required">
												عنوان شغلی خود را وارد کنید
											</div>
											<small id="" class="form-text text-danger">{{
												$t("register.jobDanger")
											}}</small>
										</div>
									</div>
								</div>

								<div class="row justify-content-between">
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.income") }}</label
											>

											<vue-numeric
												id="income"
												separator=","
												v-model.trim="$v.income.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.income.$error }"
												@blur="$v.income.$touch()"
											></vue-numeric>
											<div class="invalid-feedback" v-if="!$v.income.required">
												حدود درآمد را وارد کنید
											</div>
											<div class="invalid-feedback" v-if="!$v.income.minValue">
												حدود درآمد را صحیح وارد کنید
											</div>
											<div
													class="invalid-feedback"
													v-if="!$v.income.maxValue"
												>
													حدود درآمد را به میلیون ریال وارد کنید
												</div>
										</div>
									</div>

									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.zipCode") }}</label
											>
											<tooltip
												effect="scale"
												trigger="click"
												placement="top"
												content=" برای دریافت کد پستی خودمی توانید به سامانه
												<span
													><a
														href='https://epostcode.post.ir/'
														target='_blank'
														rel='noopener noreferrer'
														>کد پستی</a
													></span
												>
												مراجعه کنید ."
											>
												<a class="popover_btn">
													راهنما
												</a>
											</tooltip>
											<input
												id="zipCode"
												type="number"
												@wheel="$event.target.blur()"
												v-model.trim="$v.zipCode.$model"
												class="form-control"
												:class="{ 'is-invalid': $v.zipCode.$error }"
												@blur="$v.zipCode.$touch()"
											/>
											<div class="invalid-feedback" v-if="!$v.zipCode.required">
												{{ $t("customerData.Errors.postalcode required") }}
											</div>
											<div
												class="invalid-feedback"
												v-if="!$v.zipCode.checkZipCode"
											>
												{{ $t("customerData.Errors.postalcode.notEnvalid") }}
											</div>
										</div>
									</div>
								</div>

								<div class="row justify-content-between">
									<div class="col-md-5">
										<div class="form-group">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.costomerType") }}</label
											>
											<select
												class="form-control form-control-sm"
												:class="{ 'is-invalid': $v.is_organ.$error }"
												id="costomerType"
												v-model.trim="$v.is_organ.$model"
											>
												<option value="true">سازمانی</option>
												<option value="false">آزاد</option>
											</select>
											<div
												class="invalid-feedback"
												v-if="!$v.is_organ.required"
											>
												نوع کاربری را وارد نمایید
											</div>
										</div>
									</div>

									<div class="col-md-5">
										<div class="form-group" v-if="this.is_organ === 'True'">
											<label
												class="form__label text-uppercase font-size--15 font-w--500"
												>{{ $t("register.organizationCode") }}</label
											>
											<input
												id="organizationCode"
												type="text"
												v-model="organizationCode"
												class="form-control"
												required
											/>
										</div>
									</div>
								</div>
							</div>
							<!-------------------------------------     address  ------------------------------------------->

							<br />
							<br />
							<div
								class="d-flex justify-content-between align-items-center flex-column"
							>
								<button
									class="btn btn-bg--primary btn-size--md btn-hover--3d"
									type="submit"
									@click.prevent="updateCostumer"
								>
									<span class="btn__text">ثبت</span>
								</button>
							</div>
						</form>
						<!-- end of form -->
					</div>
					<!-- end of from area -->
				</div>
				<!-- end of col -->
			</div>
			<!-- end of row -->
		</div>
		<!-- end of container -->

		<!-- =========== End of Body ============ -->
	</div>
</template>

<script>
	//import VuePersianDatetimePicker from "vue-persian-datetime-picker";
	import VueNumeric from "vue-numeric";
	// import {
	//   required,
	//   minValue,

	// } from "vuelidate/lib/validators";
	import { tooltip } from "vue-strap";
	import { customerDataMixin } from "../../mixins/validationMixin";
	export default {
		data() {
			return {
				alert: false,
				errors: [],
				jobClass: "",
				job: "",
				is_organ: false,
				organizationCode: "",
				income: "",
				zipCode: "",
				organShow: false,
			};
		},
		mixins: [customerDataMixin],
		methods: {
			organization() {
				if (this.costomerType === "organization") {
					this.organShow = true;
					return this.organShow;
				}
				return this.organShow;
			},
			updateCostumer() {
				const costumer_data = {
					job_class: this.jobClass,
					job: this.job,
					status: "0",
					estimate_income: this.income,
					is_organ: this.is_organ,
					organ_code: this.organizationCode,
					postal_code: this.zipCode,
				};
				this.$v.$touch();
				if (this.$v.$invalid) {
					this.submitStatus = "ERROR";
					this.$noty.info(this.$t("alert.alertInvalidField"));
				} else {
					let load = this.$loading.show();
					this.$store
						.dispatch("updateCostumer", costumer_data)
						.then((response) => {
							console.log(response);
							this.$router.push("/customer/upload-user-docs");
							load.hide();
						})
						.catch((err) => {
							console.log(err);
							this.alert = true;
							this.errors = err.body;
							this.$noty.error(err.body.Error);
							load.hide();
						});
				}
			},
		},
		// validations: {
		//   job: {
		//     required,
		//   },
		//   jobClass: {
		//     required,
		//   },
		//   income: {
		//     required,
		//     minValue: minValue(10000000),
		//   },
		//   zipCode: {
		//     required,
		//     checkZipCode(code) {
		// 				if (
		// 					!/^\d{10}$/.test(code) ||
		// 					code == "0000000000" ||
		// 					code == "1111111111" ||
		// 					code == "2222222222" ||
		// 					code == "3333333333" ||
		// 					code == "4444444444" ||
		// 					code == "5555555555" ||
		// 					code == "6666666666" ||
		// 					code == "7777777777" ||
		// 					code == "8888888888" ||
		//           code == "9999999999" ||
		//           code == "1234567890" ||
		//           code == "0123456789" ||
		//           code == "1234567899" ||
		//           code == "1122334455" ||
		//           code == "0987654321" ||
		//           code == "9876543210"
		// 				)
		// 					return false;

		//         else return true;
		// 			},
		//   },
		//   is_organ: {
		//     required,
		//   },
		// },
		components: {
			VueNumeric,
			tooltip,
		},
	};
</script>

<style>
	.vpd-icon-btn {
		display: flex;
		width: 1%;
		cursor: pointer;
		padding: 0 10px;
	}
	.popover_btn {
		background-color: rgb(189, 192, 189);
		border-radius: 50%;
		border: none;
		color: #000000;
		padding: 10px;
		text-align: center;
		text-decoration: none;
		display: inline-block;
		font-size: 12px;
		margin: 4px 6px;
	}
</style>
